import React, { FC } from 'react';
import { ForgeButton, ForgeIcon, ForgeToolbar } from '@tylertech/forge-react';
import { I18n } from 'common/i18n';
import { deleteScheduleDelivery } from 'common/components/ScheduleSendReport/services';
import { showForgeSuccessToastNow } from 'common/components/ToastNotification/Toastmaster';
import { useError } from 'common/components/ScheduleSendReport/context/errorContext';

const scope = 'shared.components.schedule_send_report.modal';

interface FooterProps {
  onDismiss: () => void;
  onEdit: () => void;
}

const PreviewFooter: FC<FooterProps> = ({ onDismiss, onEdit }) => {
  const { formButtonsDisabled, setError } = useError();
  const onDelete = async () => {
    const response = await deleteScheduleDelivery();
    if (response.success) {
      showForgeSuccessToastNow(I18n.t('delete_toast', { scope }));
      onDismiss();
    } else {
      setError({ action: 'deleting', errorKey: response.errorKey, statusCode: response.statusCode });
    }
  };

  return (
    <ForgeToolbar inverted={true} className="footer-toolbar">
      <div slot="start">
        <ForgeButton
          theme="error"
          variant="text"
          onClick={onDelete}
          aria-label={I18n.t('delete_aria_label', { scope })}
          data-testid="preview-delete-button"
          disabled={formButtonsDisabled}
        >
          <ForgeIcon name="trash_can_outline" />
          {I18n.t('delete', { scope })}
        </ForgeButton>
      </div>
      <div slot="end">
        <ForgeButton
          variant="outlined"
          onClick={onDismiss}
          aria-label={I18n.t('close_preview_aria_label', { scope })}
        >
          {I18n.t('close', { scope })}
        </ForgeButton>
        <ForgeButton
          variant="raised"
          onClick={onEdit}
          aria-label={I18n.t('edit_scheduled_report_aria_label', { scope })}
          data-testid="preview-edit-button"
          disabled={formButtonsDisabled}
        >
          <ForgeIcon name="edit" aria-hidden="false" external external-type="extended" />
          {I18n.t('edit_schedule', { scope })}
        </ForgeButton>
      </div>
    </ForgeToolbar>
  );
};

export default PreviewFooter;
